
    import '/opt/buildhome/repo/components/actions/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["actions-demo-basic","actions-demo-sub","actions-demo-variant"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/actions/index.zh-CN.md?type=demo')
};